<app-create-contact-drawer [allFields]="allFields" [entityAddFormFields]="entityAddFormFields" [allUsers]="allUsers"
    *ngIf="isAddContactDrawerOpen && allFields.length && entityAddFormFields.length"></app-create-contact-drawer>

<app-create-activity-modal [allActivitiesDefinitionDocument]="allActivityDefinitions" [allUsers]="allUsers"
    [entityType]="entityType" [entityId]="entityId" [currentActivityType]="currentActivityType" [isLog]="isLog"
    *ngIf="isAddActivityModalOpen && allActivityDefinitions.length"></app-create-activity-modal>

<ym-toast></ym-toast>